import { withTranslation } from "react-i18next";

import React from 'react';
import { Footer } from '../Common/Footer';
import { Header } from '../Common';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import axios from 'axios';
import Profile from '../../Models/Profile';
import { AffiliatorSidebar } from '../Common/AffiliatorSidebar';
import { ToastContainer, toast } from 'react-toastify';
import Common from "../../Models/Common";

class AffiliatorProfile extends React.Component {
    constructor(props) {
        super(props);
        let x = JSON.parse(localStorage.getItem('info'))
        if (x === null || x === '' || x.user_type_id !== 3) {
            alert(this.props.t('1'))
            this.props.history.push('/login/affiliator');
        };
        var retrievedObject = window.localStorage.getItem('info');
        var logged_user = JSON.parse(retrievedObject);
        // console.log(">>>>>>>>>>>>>>", logged_user);
        this.state = {
            _id: false,
            user: logged_user,
            modal: false,
            profession: '',
            photo_id: null,
            utility: null,
            residential: [],
            services: [],
            portfolio: [],
            sex: [],
            area: '',
            address: '',
            x: '',
            profile_picture: null,
            profile: [],
            username: logged_user.first_name,
            phone: '',
            email: '',
            creditcard: '',
            t_account: '',

            bank_name: '',
            branch_name: '',
            account_name: '',
            account_type: ''
        };
    }
    componentDidMount() {
        window.scrollTo(0, 0)
        Profile.getResidentials().then(res => {
            if (res.data.area != null) {
                this.setState({ residential: res.data.area })
            }
        })
        Profile.getSex().then(res => {
            if (res.data.sex != null) {
                this.setState({ sex: res.data.sex })
            }
        })
        Profile.getBasics(this.state.user.id).then(res => {
            if (res.data.payloads != null) {
                this.setState({ profile: res.data.payloads })
                this.setState({ profession: res.data.payloads.profession })
                this.setState({ photo_id: res.data.payloads.pid })
                this.setState({ profile_picture: res.data.payloads.profile_image })
                this.setState({ utility: res.data.payloads.ut })
                this.setState({ x: res.data.payloads.sex })
                this.setState({ area: res.data.payloads.residential_area })

                if (res.data.payloads.address !== 'null') {
                    if (res.data.payloads.address !== " ") {
                        this.setState({ address: res.data.payloads.address })
                    }
                }
            }
        })
        Profile.getConfiguration(this.state.user.id).then(res => {
            if (res.data.payload != null) {
                this.setState({ username: res.data.payload.first_name })
                if (res.data.payload.phone !== 'null') {
                    if (res.data.payload.phone !== " ") {
                        this.setState({ phone: res.data.payload.phone })
                    }
                }
                this.setState({ email: res.data.payload.email })

                if (res.data.payload.credit_card !== 'null') {
                    if (res.data.payload.credit_card !== " ") {
                        this.setState({ creditcard: res.data.payload.credit_card })
                    }
                }
                if (res.data.payload.transfer_account !== 'null') {
                    this.setState({ t_account: res.data.payload.transfer_account })
                }
                if (res.data.payload.bank_name !== 'null') {
                    if (res.data.payload.bank_name !== " ") {
                        this.setState({ bank_name: res.data.payload.bank_name })
                    }
                }
                if (res.data.payload.branch_name !== 'null') {
                    if (res.data.payload.branch_name !== " ") {
                        this.setState({ branch_name: res.data.payload.branch_name })
                    }
                }
                if (res.data.payload.account_name !== 'null') {
                    if (res.data.payload.account_name !== " ") {
                        this.setState({ account_name: res.data.payload.account_name })
                    }
                }
                if (res.data.payload.account_type == 'general') {
                    this.setState({ account_type: '1' })
                } else if (res.data.payload.account_type == 'current') {
                    this.setState({ account_type: '2' })
                } else {
                    this.setState({ account_type: '3' })
                }
            }
        })
    }

    onChangePro(e) {
        this.setState({ profile_picture: e.target.files[0] })
    }

    onChange(e) {
        this.setState({ photo_id: e.target.files[0] })
    }

    onChange_ut(e) {
        this.setState({ utility: e.target.files[0] })
    }

    toggle() {
        this.setState(prevState => ({
            modal: !prevState.modal
        }));
    }

    toggleAll() {
        this.setState({
            modal: false
        });
    }

    updateValue(type, e) {
        var obj = {};
        obj[type] = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        this.setState(obj);
    }

    details(details) {
        const renderHTML = (rawHTML) => React.createElement("div", { dangerouslySetInnerHTML: { __html: rawHTML } });
        if (details === null || details === '') {
            return (
                renderHTML(details)
            )
        } else {
            return (
                renderHTML(details.substr(0, 50))
            )
        }
    }

    handleSubmit(e) {
        e.preventDefault();
        toast(this.props.t(this.props.t('46')),{
            position: "top-center",
            toastId: "customId",
            autoClose: false
        });
        // this.state.area = this.refs.Area.value;
        this.state.x = this.refs.Sex.value;
        Profile.checkusername(this.state.username, this.state.user.id).then(res => {
            if (res.data.status != 404) {
                this.setState({ username: '' })
                toast.dismiss("customId");
                toast(this.props.t('0'),{
                    position: "top-center",
                    toastId: "customId2",
                    autoClose: 3000
                });
                this.toggle();
                // alert(this.props.t('0'));
                return;
            } else {
                toast.dismiss("customId");
                const formData = new FormData();
                formData.append('user_id', this.state.user.id)
                formData.append('profession', this.state.profession)
                formData.append('photo_id', this.state.photo_id)
                formData.append('profile_picture', this.state.profile_picture)
                formData.append('utility', this.state.utility)
                formData.append('sex', this.state.x)
                formData.append('area', this.state.area)
                formData.append('address', this.state.address)
                formData.append('username', this.state.username)
                formData.append('phone', this.state.phone)
                formData.append('email', this.state.email)
                formData.append('creditcard', this.state.creditcard)
                formData.append('t_account', this.state.t_account)
                formData.append('bank_name', this.state.bank_name)
                formData.append('branch_name', this.state.branch_name)
                formData.append('account_name', this.state.account_name)
                formData.append('account_type', this.state.account_type)
                axios({
                    method: 'post',
                    url: Common.api + 'update-basic-profile',
                    // url: 'http://192.168.1.110/sharework_back_v2/public/backend/update-basic-profile',
                    data: formData,
                    config: {
                        headers: {
                            'content-type': 'multipart/form-data'
                        }
                    }
                }).then(res => {
                    if (res.data.message === "Success") {
                        // toast('Wow so easy !', { containerId: 'A' });
                        toast.dismiss("customId");
                        toast(this.props.t('47'),{
                            position: "top-center",
                            toastId: "customId2",
                            autoClose: 3000
                        });
                        window.localStorage.setItem('pro_pic', JSON.stringify(res.data.profile_pic))
                        window.localStorage.setItem('pro_name', JSON.stringify(this.state.username))
                        this.toggle();
                        // window.location.reload()
                    }
                })
            }
        })
        toast.dismiss("customId");
    }

    profileImage() {
        if (this.state.profile.img === '' || this.state.profile.img === null) {
            return (
                <div style={{ width: "100%", textAlign: "center" }}>
                    <img alt="" src={require("../../assets/images/image1.jpeg")} height="100" width='100' style={{ objectFit: 'cover', borderRadius: "50%" }} />
                </div>
            )
        } else {
            return (
                <div style={{ width: "100%", textAlign: "center" }}>
                    <img alt="" src={Common.baseUrl + this.state.profile.img} height="100" width='100' style={{ objectFit: 'cover', borderRadius: "50%" }} />
                </div>
            )
        }
    }

    editProfile() {
        return (
            <div className="">
                <Button color="" className=" mt-3" onClick={this.toggle.bind(this)} style={{ color: '#444', cursor: 'pointer', height: '35px', border: "1px solid #ccc" }}>{this.props.t('2')}</Button>
                <Modal className="modal-lg" isOpen={this.state.modal} toggle={this.toggle.bind(this)} >
                    <ModalHeader toggle={this.toggle.bind(this)}>{this.props.t('9')}</ModalHeader>
                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                    </button>
                    <ModalBody>
                        <div style={{}}>
                            <form>
                                <fieldset style={{ border: "1px solid #008dc7", paddingLeft: "4%", paddingRight: "4%", paddingBottom: "4%" }}>
                                    <legend style={{ width: "22%", color: "#008dc7", fontSize: "12px" }}>{this.props.t('3')}:</legend>
                                    <div>&nbsp;</div>
                                    <div style={{ width: "100%", textAlign: "center" }}>
                                        <span style={{ fontSize: "13px" }}>{this.props.t('4')}</span>
                                    </div>
                                    {this.profileImage()}
                                    <div>&nbsp;</div>
                                    <div style={{ width: "100%", textAlign: "center", paddingLeft: "15%" }}>
                                        <input style={{ fontSize: "13px" }} type="file" onChange={this.onChangePro.bind(this)} />
                                    </div>
                                    <div>&nbsp;</div>
                                    <div className="col-md-12 row" style={{ textAlign: 'center' }}>
                                        <div className="col-md-6">
                                            <div style={{ fontSize: "13px" }}>{this.props.t('19')}</div>
                                            {(() => {
                                                if (this.state.profile.pid === '' || this.state.profile.pid === null) {
                                                    return (
                                                        <div><img style={{ borderRadius: "50%" }} alt="" src={require("../../assets/images/default-img.png")} height="100px" width='40%' /></div>
                                                    )
                                                } else {
                                                    return (
                                                        <div><img alt="" src={Common.baseUrl + this.state.profile.pid} height="100px" width='40%' /></div>
                                                    )
                                                }
                                            })()}
                                            <div>&nbsp;</div>
                                            <div><input style={{ fontSize: "13px", paddingLeft: '65px' }} type="file" onChange={this.onChange.bind(this)} /></div>
                                            <div>&nbsp;</div>
                                        </div>
                                        <div className="col-md-6">
                                            <div style={{ fontSize: "13px" }}>{this.props.t('10')}</div>
                                            {(() => {
                                                if (this.state.profile.ut === '' || this.state.profile.ut === null) {
                                                    return (
                                                        <div><img alt="" src={require("../../assets/images/default-img.png")} height="100px" width='40%' /></div>
                                                    )
                                                } else {
                                                    return (
                                                        <div><img alt="" src={Common.baseUrl + this.state.profile.ut} height="100px" width='40%' /></div>
                                                    )
                                                }
                                            })()}
                                            <div>&nbsp;</div>
                                            <div><input style={{ fontSize: "13px", paddingLeft: '65px' }} type="file" onChange={this.onChange_ut.bind(this)} /></div>
                                            <div>&nbsp;</div>
                                        </div>
                                    </div>
                                    <div>&nbsp;</div>
                                    <div style={{ fontSize: "13px" }}>{this.props.t('40')}</div>
                                    <div>
                                        <select ref="Sex" style={{ fontSize: "13px", width: "25%", height: "35px" }}
                                            value={this.state.x} onChange={this.updateValue.bind(this, 'x')}>
                                            <option value="">----</option>
                                            {this.state.sex.map(rp =>
                                                <option value={rp.id} key={rp.id} >
                                                    {rp.description}
                                                </option>
                                            )}
                                        </select>
                                    </div>
                                    <div>&nbsp;</div>
                                    {/*<div style={{ fontSize: "13px" }}>{this.props.t('11')}</div>*/}
                                    {/*<div>*/}
                                    {/*    <select ref="Area" style={{ fontSize: "13px", width: "40%", height: "35px" }}*/}
                                    {/*        value={this.state.area} onChange={this.updateValue.bind(this, 'area')}>*/}
                                    {/*        <option value="">------</option>*/}
                                    {/*        {this.state.residential.map(rp =>*/}
                                    {/*            <option value={rp.id} key={rp.id} >*/}
                                    {/*                {rp.area}*/}
                                    {/*            </option>*/}
                                    {/*        )}*/}
                                    {/*    </select>*/}
                                    {/*</div>*/}
                                    {/*<div>&nbsp;</div>*/}
                                    <div style={{ fontSize: "13px" }}>{this.props.t('41')}</div>
                                    <div>
                                        <textarea style={{ fontSize: "13px", width: "70%", height: "80px", border: "1px solid gray", borderRadius: "4px", padding: "2%" }}
                                            value={this.state.address} onChange={this.updateValue.bind(this, 'address')}>
                                        </textarea>
                                    </div>
                                    <div>&nbsp;</div>

                                </fieldset>
                                <div>&nbsp;</div>
                                <fieldset style={{ border: "1px solid #008dc7", padding: "4%" }}>
                                    <legend style={{ width: "25%", color: "#008dc7", fontSize: "12px" }}>{this.props.t('5')}:</legend>
                                    <div style={{ fontSize: "13px" }}>{this.props.t('20')}</div>
                                    <div>
                                        <input value={this.state.username} type="text" style={{
                                            fontSize: "13px", width: "60%", border: "1px solid #d2d2d2", borderRadius: "4px",
                                            padding: "1%", fontSize: "14px"
                                        }} onChange={this.updateValue.bind(this, 'username')}></input>
                                    </div>
                                    <div>&nbsp;</div>
                                    <div style={{ fontSize: "13px" }}>{this.props.t('24')}</div>
                                    <div>
                                        <input value={this.state.phone} type="text" style={{
                                            fontSize: "13px", width: "60%", border: "1px solid #d2d2d2", borderRadius: "4px",
                                            padding: "1%", fontSize: "14px"
                                        }} onChange={this.updateValue.bind(this, 'phone')}></input>
                                    </div>
                                    <div>&nbsp;</div>
                                    <div style={{ fontSize: "13px" }}>{this.props.t('6')}</div>
                                    <div>
                                        <input value={this.state.email} type="text" style={{
                                            fontSize: "13px", width: "60%", border: "1px solid #d2d2d2", borderRadius: "4px",
                                            padding: "1%", fontSize: "14px"
                                        }} onChange={this.updateValue.bind(this, 'email')}></input>
                                    </div>
                                    <div>&nbsp;</div>
                                    <div style={{ fontSize: "13px" }}>{this.props.t('12')}</div>
                                    <div>
                                        <input style={{ fontSize: "13px", width: "70%", border: "1px solid gray", borderRadius: "4px", padding: "1%" }}
                                            value={this.state.bank_name} placeholder={this.props.t('34')} onChange={this.updateValue.bind(this, 'bank_name')}>
                                        </input>
                                        {/* <input value={this.state.t_account} type="" style={{
                                        fontSize: "13px", width: "60%", border: "1px solid #d2d2d2", borderRadius: "4px",
                                        padding: "1%", fontSize: "14px"
                                    }} onChange={this.updateValue.bind(this, 't_account')}></input> */}
                                    </div>
                                    <div>&nbsp;</div>
                                    <div>
                                        <input style={{ fontSize: "13px", width: "70%", border: "1px solid gray", borderRadius: "4px", padding: "1%" }}
                                            value={this.state.branch_name} placeholder={this.props.t('35')} onChange={this.updateValue.bind(this, 'branch_name')}>
                                        </input>
                                    </div>
                                    <div>&nbsp;</div>
                                    <div>
                                        <span>{this.props.t('42')} : &nbsp;&nbsp;</span>
                                        <input type="radio" id="male" name="gender" value="1" checked={this.state.account_type === '1'} onChange={this.updateValue.bind(this, 'account_type')}></input>&nbsp;
                                        <label for="male">{this.props.t('43')}</label>&nbsp;&nbsp;
                                        <input type="radio" id="male" name="gender" value="2" checked={this.state.account_type === '2'} onChange={this.updateValue.bind(this, 'account_type')}></input>&nbsp;
                                        <label for="male">{this.props.t('44')}</label>&nbsp;&nbsp;
                                        <input type="radio" id="male" name="gender" value="3" checked={this.state.account_type === '3'} onChange={this.updateValue.bind(this, 'account_type')}></input>&nbsp;
                                        <label for="male">{this.props.t('45')}</label>
                                    </div>
                                    <div>&nbsp;</div>
                                    <div>
                                        <input type="number" style={{ fontSize: "13px", width: "70%", border: "1px solid gray", borderRadius: "4px", padding: "1%" }}
                                            value={this.state.t_account} placeholder={this.props.t('25')} onChange={this.updateValue.bind(this, 't_account')}>
                                        </input>
                                    </div>
                                    <div>&nbsp;</div>
                                    <div>
                                        <input style={{ fontSize: "13px", width: "70%", border: "1px solid gray", borderRadius: "4px", padding: "1%" }}
                                            value={this.state.account_name} placeholder={this.props.t('26')} onChange={this.updateValue.bind(this, 'account_name')}>
                                        </input>
                                    </div>


                                </fieldset>
                                <div>&nbsp;</div>
                            </form>
                        </div>

                    </ModalBody>
                    <ModalFooter>
                        <Button onClick={this.handleSubmit.bind(this)} style={{ borderRadius: "4px", border: "1px solid", backgroundColor: "#1eb2ef", color: "white", padding: "1%" }}>{this.props.t('27')}</Button>
                        <Button color="secondary" data-dismiss="modal" onClick={this.toggle.bind(this)} style={{ borderRadius: "4px", border: "1px solid gray", backgroundColor: "white", color: "black", padding: "1%" }}>{this.props.t('21')}</Button>
                    </ModalFooter>
                </Modal>
            </div>
        )
    }

    render() {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        if (isMobile) {
            return (
                <div  className="wrapper">
                    <ToastContainer />
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="col-md-12 tr_blank_medium mt-5 "></div>
                    <div className="container-fluid request_fonts main">
                        <div className="row">
                            {/* <div className="col-md-4 input_name">
                                        <AffiliatorSidebar />
                                    </div> */}

                            <div className="col-md-12">
                                <div className="mb-2 input_name big_font guide_text" style={{ fontSize: '20px', width: '100%' }}>
                                    {this.props.t('9')}
                                </div>
                                <div className="container">
                                    <div className="col-md-4">
                                        {this.profileImage()}
                                    </div>
                                    <div className="col-md-4 text-center">
                                        {this.editProfile()}
                                    </div>
                                    <div className="mt-2" style={{ border: "1px solid rgb(241, 240, 238)", padding: "10px", textAlign: "center", height: "auto" }}>
                                        <div className=" row">
                                            <div className="col-5  personal-info-mobile">
                                                {this.props.t('40')} :
                                            </div>
                                            <div className="col-7  personal-info-mobile">
                                                {this.state.profile.sx}
                                            </div>
                                        </div>
                                        {/*<div className=" row">*/}
                                        {/*    <div className="col-5  personal-info-mobile">*/}
                                        {/*        {this.props.t('11')} :*/}
                                        {/*    </div>*/}
                                        {/*    <div className="col-7  personal-info-mobile">*/}
                                        {/*        {this.state.profile.area}*/}
                                        {/*    </div>*/}
                                        {/*</div>*/}
                                        <div className=" row">
                                            <div className="col-5  personal-info-mobile">
                                                {this.props.t('41')} :
                                            </div>
                                            <div className="col-7  personal-info-mobile">
                                                {(() => {
                                                    if (this.state.address !== null) {
                                                        return (
                                                            this.state.address.split('\n').map((item, key) =>
                                                                <span key={key}>
                                                                    {item}
                                                                    <br />
                                                                </span>
                                                            ))
                                                    }
                                                })()}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="mt-2" style={{ border: "1px solid rgb(241, 240, 238)", padding: "10px", textAlign: "center", height: "auto" }}>
                                        <div className="row">
                                            <div className="col-5  personal-info-mobile">
                                                {this.props.t('20')} :
                                            </div>
                                            <div className="col-7  personal-info-mobile">
                                                {this.state.username}
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-5 personal-info-mobile">
                                                {this.props.t('24')} :
                                            </div>
                                            <div className="col-7  personal-info-mobile">
                                                {this.state.phone}
                                            </div>
                                        </div>
                                        <div className=" row">
                                            <div className="col-5  personal-info-mobile">
                                                {this.props.t('6')} :
                                            </div>
                                            <div className="col-7  personal-info-mobile">
                                                {this.state.email}
                                            </div>
                                        </div>
                                        <div><br /></div>
                                        <div className=" row">
                                            <div className="col-12" style={{ textAlign: "center", paddingRight: '0px' }}>
                                                {this.props.t('12')}
                                            </div>
                                        </div><br />
                                        <div className=" row">
                                            <div className="col-5  personal-info-mobile">
                                                {this.props.t('34')} :
                                            </div>
                                            <div className="col-7 personal-info-mobile">
                                                {this.state.bank_name}
                                            </div>
                                        </div>
                                        <div className=" row">
                                            <div className="col-5 personal-info-mobile">
                                                {this.props.t('35')} :
                                            </div>
                                            <div className="col-7  personal-info-mobile">
                                                {this.state.branch_name}
                                            </div>
                                        </div>
                                        <div className=" row">
                                            <div className="col-5  personal-info-mobile">
                                                {this.props.t('25')} :
                                            </div>
                                            <div className="col-7 personal-info-mobile">
                                                {this.state.t_account}
                                            </div>
                                        </div>
                                        <div className=" row">
                                            <div className="col-5 personal-info-mobile">
                                                {this.props.t('26')} :
                                            </div>
                                            <div className="col-7 personal-info-mobile">
                                                {this.state.account_name}
                                            </div>
                                        </div>
                                        <div className=" row">
                                            <div className="col-5  personal-info-mobile">
                                                {this.props.t('42')} :
                                            </div>
                                            <div className="col-7 personal-info-mobile">
                                                {(() => {
                                                    if (this.state.account_type == '1') {
                                                        return (
                                                            <div>{this.props.t('43')}</div>
                                                        )
                                                    } else if (this.state.account_type == '2') {
                                                        return (
                                                            <div>{this.props.t('44')}</div>
                                                        )
                                                    } else {
                                                        return (
                                                            <div>{this.props.t('45')}</div>
                                                        )
                                                    }
                                                })()}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            )
        }
        //for desktop view
        else if (isDesktop) {
            return (
                <div className="wrapper">
                    <ToastContainer />
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="col-md-12 tr_blank_medium mt-5"></div>
                    <div className="container-fluid main">
                        <div className="container">
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-4 input_name">
                                        <AffiliatorSidebar />
                                    </div>

                                    <div className="col-md-8">
                                        <div className="mb-3 input_name big_font guide_text" style={{ width: '100%' }}>
                                            {this.props.t('9')}
                                    </div>

                                        <div className="container">
                                            <div className="mt-3 row" style={{ height: '100px' }}>
                                                <div className="col-md-4"></div>
                                                <div className="col-md-4">
                                                    {this.profileImage()}
                                                </div>
                                                <div className="col-md-4 text-right">
                                                    {this.editProfile()}
                                                </div>
                                            </div>
                                            <div className="mt-2" style={{ border: "1px solid rgb(241, 240, 238)", padding: "22px", textAlign: "center", height: "auto" }}>
                                                <div className="col-md-12 row">
                                                    <div className="col-md-4" style={{ textAlign: "right" }}>
                                                        <b><i>{this.props.t('40')}:</i></b>
                                                    </div>
                                                    <div className="col-md-1"></div>
                                                    <div className="col-md-7" style={{ textAlign: "left" }}>
                                                        {this.state.profile.sx}
                                                    </div>
                                                </div>
                                                {/*<div className="col-md-12 row">*/}
                                                {/*    <div className="col-md-4" style={{ textAlign: "right" }}>*/}
                                                {/*        <b><i>{this.props.t('11')}:</i></b>*/}
                                                {/*    </div>*/}
                                                {/*    <div className="col-md-1"></div>*/}
                                                {/*    <div className="col-md-7" style={{ textAlign: "left" }}>*/}
                                                {/*        {this.state.profile.area}*/}
                                                {/*    </div>*/}
                                                {/*</div>*/}
                                                <div className="col-md-12 row">
                                                    <div className="col-md-4" style={{ textAlign: "right" }}>
                                                        <b><i>{this.props.t('41')}:</i></b>
                                                    </div>
                                                    <div className="col-md-1"></div>
                                                    <div className="col-md-7" style={{ textAlign: "left", height: "50px" }}>
                                                        {(() => {
                                                            if (this.state.address !== null) {
                                                                return (
                                                                    this.state.address.split('\n').map((item, key) =>
                                                                        <span key={key}>
                                                                            {item}
                                                                            <br />
                                                                        </span>
                                                                    ))
                                                            }
                                                        })()}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="mt-5" style={{ border: "1px solid rgb(241, 240, 238)", padding: "22px", textAlign: "center", height: "auto" }}>
                                                <div className="col-md-12 row">
                                                    <div className="col-md-4" style={{ textAlign: "right" }}>
                                                        <b><i>{this.props.t('20')}:</i></b>
                                                    </div>
                                                    <div className="col-md-1"></div>
                                                    <div className="col-md-7" style={{ textAlign: "left" }}>
                                                        {this.state.username}
                                                    </div>
                                                </div>
                                                <div className="col-md-12 row">
                                                    <div className="col-md-4" style={{ textAlign: "right" }}>
                                                        <b><i>{this.props.t('24')}:</i></b>
                                                    </div>
                                                    <div className="col-md-1"></div>
                                                    <div className="col-md-7" style={{ textAlign: "left" }}>
                                                        {this.state.phone}
                                                    </div>
                                                </div>
                                                <div className="col-md-12 row">
                                                    <div className="col-md-4" style={{ textAlign: "right" }}>
                                                        <b><i>{this.props.t('6')}:</i></b>
                                                    </div>
                                                    <div className="col-md-1"></div>
                                                    <div className="col-md-7" style={{ textAlign: "left" }}>
                                                        {this.state.email}
                                                    </div>
                                                </div>
                                                <div className="col-md-12"><br /></div>
                                                <div className="col-md-12 row">
                                                    <div className="col-md-4" style={{ textAlign: "right" }}>
                                                        <b><i>{this.props.t('12')}</i></b>
                                                    </div>
                                                    <div className="col-md-1"></div>
                                                    <div className="col-md-7" style={{ textAlign: "left" }}>

                                                    </div>
                                                </div>
                                                <div className="col-md-12 row">
                                                    <div className="col-md-4" style={{ textAlign: "right" }}>
                                                        <b><i>{this.props.t('34')} : </i></b>
                                                    </div>
                                                    <div className="col-md-1"></div>
                                                    <div className="col-md-7" style={{ textAlign: "left" }}>
                                                        {this.state.bank_name}
                                                    </div>
                                                </div>
                                                <div className="col-md-12 row">
                                                    <div className="col-md-4" style={{ textAlign: "right" }}>
                                                        <b><i>{this.props.t('35')} : </i></b>
                                                    </div>
                                                    <div className="col-md-1"></div>
                                                    <div className="col-md-7" style={{ textAlign: "left" }}>
                                                        {this.state.branch_name}
                                                    </div>
                                                </div>
                                                <div className="col-md-12 row">
                                                    <div className="col-md-4" style={{ textAlign: "right" }}>
                                                        <b><i>{this.props.t('25')} : </i></b>
                                                    </div>
                                                    <div className="col-md-1"></div>
                                                    <div className="col-md-7" style={{ textAlign: "left" }}>
                                                        {this.state.t_account}
                                                    </div>
                                                </div>
                                                <div className="col-md-12 row">
                                                    <div className="col-md-4" style={{ textAlign: "right" }}>
                                                        <b><i>{this.props.t('26')} : </i></b>
                                                    </div>
                                                    <div className="col-md-1"></div>
                                                    <div className="col-md-7" style={{ textAlign: "left" }}>
                                                        {this.state.account_name}
                                                    </div>
                                                </div>
                                                <div className="col-md-12 row">
                                                    <div className="col-md-4" style={{ textAlign: "right" }}>
                                                        <b><i>{this.props.t('42')} : </i></b>
                                                    </div>
                                                    <div className="col-md-1"></div>
                                                    <div className="col-md-7" style={{ textAlign: "left" }}>
                                                        {(() => {
                                                            if (this.state.account_type == '1') {
                                                                return (
                                                                    <div>{this.props.t('43')}</div>
                                                                )
                                                            } else if (this.state.account_type == '2') {
                                                                return (
                                                                    <div>{this.props.t('44')}</div>
                                                                )
                                                            } else {
                                                                return (
                                                                    <div>{this.props.t('45')}</div>
                                                                )
                                                            }
                                                        })()}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            )
        }
    }
}
export { AffiliatorProfile }


 AffiliatorProfile = withTranslation('src_Components_Profile_AffiliatorProfile')(AffiliatorProfile);
